import { render } from "./App.vue?vue&type=template&id=3b8489ba&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b8489ba&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.2.2_b3222d3da5d2ef56209cdae4c4adc42e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8489ba"]])

export default __exports__